import type { FC } from 'react';

import { elevatorStyle, filePickerTextStyle, listItemStyle } from './FilePicker.css';
import { CheckIcon, CloseIcon, DocumentIcon, ErrorIcon } from '../../icons';
import { getClassNames } from '../../util/css';
import { Bleed } from '../Bleed/Bleed';
import { IconButton } from '../IconButton/IconButton';
import { NotificationBox } from '../Notification/NotificationBox';
import { Stack } from '../Stack/Stack';
import { textRecipe } from '../Text/Text.css';

type UploadItemProps = ({ state: 'success'; errorMessage?: never } | { state: 'error'; errorMessage: string }) & {
  name: string;
  onDelete: () => void;
};

const uploadItemIcon = { success: <CheckIcon color="feedbackSuccess" />, error: <ErrorIcon color="feedbackError" /> };

export const UploadItem: FC<UploadItemProps> = ({ state, errorMessage, name, onDelete }) => (
  <li className={listItemStyle}>
    <Stack gap="2">
      <Stack gap="2" direction="row" alignY="center">
        <DocumentIcon />
        <span className={getClassNames(textRecipe({ size: 'BodyS', weight: 'bold' }), filePickerTextStyle)}>
          {name}
        </span>
        <Stack.Item grow>{uploadItemIcon[state]}</Stack.Item>
        <div className={elevatorStyle}>
          <Bleed right="4" vertical="4">
            <IconButton onClick={onDelete} label={`Remove file ${name}`}>
              <CloseIcon />
            </IconButton>
          </Bleed>
        </div>
      </Stack>
      {errorMessage ? <NotificationBox variant="error" text={errorMessage} isAlert /> : null}
    </Stack>
  </li>
);
